@if (valuesData()) {
<div class="statistics-single-value">
    <div class="value-bubble">
        <div class="content">{{ valuesData().share | rounded }}%</div>
    </div>
    <div class="info-text">
        <div class="inner-text">{{ valuesData().text }}</div>
    </div>
    <div class="range-container">
        <div class="text grey">Grunnlag</div>
        <div class="value">{{ valuesData().num }}</div>
    </div>
    <div class="info-icon" (clickOutside)="tooltip().show = false" (click)="tooltip().show = !tooltip().show">
        <ev_tooltip [visible]="tooltip().show" [left]="-270" [bottom]="27" [arrow]="'bottom'" [arrowBottomAlign]="-8" [arrowAlignRight]="17">
            <div class="popup-info">
                <div class="header">{{ tooltip().header }}</div>
                @for (txt of tooltip().info; track txt) {
                <div class="body">{{ txt }}</div>
                }
            </div>
        </ev_tooltip>
    </div>
</div>
}
